import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
declare var jquery: any;
declare var $: any;
import { GridOptions } from "ag-grid/main";
import { ToastrService } from 'ngx-toastr';
import { Globals } from '../../globals';
import { AssessmentsService, SaveAssessments360Dto } from 'app/services/assessment/AssessmentsService';
import { AdminService } from 'app/services/admin/AdminService';


@Component({
  selector: 'app-new-360-assessment',
  templateUrl: './new-360-assessment.component.html',
  styleUrls: ['./new-360-assessment.component.scss']
})
export class New360AssessmentComponent implements OnInit {
    tags: string[] =
    [
        "Business",
        "ELI",
        "New Client"
    ];

    _onRowDragEnd: any;
    _onRowDragEnter: any;
    version: string;
    niches: any[] = []

    /*--modal questions--*/
    questions = new Array();
    questionType: string;
    currentQuestionType: number;
    questionsHeaders: any[];
    questionsGridOptions: GridOptions;
    questionsGridApi;
    rowSelection;

    /*generic all ag-grid*/
    overlayNoRowsTemplate;
    height: number;
    count: number;

    /*regularSection*/
    section1_questions: any[] = [];
    deleted_section1_questions: any[] = [];
    section1Headers: any[];
    section1GridOptions: GridOptions;
    section1GridApi;

    /*satisfactionSection*/
    section2_questions: any[] = [];
    deleted_section2_questions: any[] = [];
    section2Headers: any[];
    section2GridOptions: GridOptions;
    section2GridApi;

    /*edit*/
    assessmentId: number;
    majorVersion: number;
    minorVersion: number;
    name: string;
    nicheName: string;
    nicheId: number = 0;

    section1: any;
    section2: any;
    section3: any;

    showAssessmentPreview: boolean;

    //flag to handle the deleted questions
    excludeDeleted: boolean = false;

    section1ChoiceSets: any[];
    section2ChoiceSets: any[];
    section1ChoiceSet: number = 0;
    section2ChoiceSet: number = 0;
    templateId: number;

    templates: string[] = [];

    invitations: any[] = [];
    reminders: any[] = [];
    results: any[] = [];

    invitation: number;
    result: number;
    reminder: number;

    section1Type: number = 4;
    section2Type: number = 5;
    baseEli: any[] =[];
    regularAssessment: number;



    constructor(
        private _AdminService: AdminService,
        private _AssessmentsService: AssessmentsService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService,
        private _Globals: Globals
    ) {
        this.activatedRoute.params.subscribe(params => {
            this.assessmentId = params['id'];
        });

        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        if (this._Globals.previewAssessmentId != undefined) {
            console.log('globals', this._Globals);
        }

        this.getNiches();
        this.GetChoiceSets(this.section1Type);
        this.GetChoiceSets(this.section2Type);

        /*modal*/
        this.questionsGridOptions = <GridOptions>{};
        this.questionsGridOptions.rowHeight = 45;
        this.questionsGridOptions.headerHeight = 40;
        this.questionsHeaders = this.createModalHeaders();

        /*regularSection*/
        this.section1GridOptions = <GridOptions>{};
        this.section1GridOptions.rowHeight = 45;
        this.section1GridOptions.headerHeight = 40;
        this.section1Headers = this.createSection1Headers();

        /*satisfactionSection*/
        this.section2GridOptions = <GridOptions>{};
        this.section2GridOptions.rowHeight = 45;
        this.section2GridOptions.headerHeight = 40;
        this.section2Headers = this.createSection2Headers();

        //editing
        if (this.assessmentId != undefined) {
            this.showAssessmentPreview = true;

            if (this._Globals.previewAssessmentId != undefined) {
                console.log('current Editing Assessment', this._Globals.currentEditingAssessment);
                let data = this._Globals.currentEditingAssessment;

                this.majorVersion = data.MajorVersion;
                this.minorVersion = data.MinorVersion;
                this.name = data.Name;
                this.nicheId = data.NicheName;
                this.templateId = data.TemplateId;


                if (data.Sections.length >= 1)
                    this.section1_questions = data.Sections[0].Questions;
                if (data.Sections.length >= 2)
                    this.section2_questions = data.Sections[1].Questions;

                if (data.Sections.length >= 1) {
                    let section1 = {
                        "ChoiceSetId": data.Sections[0].ChoiceSetId,
                        "Id": data.Sections[0].Id,
                        "Order": data.Sections[0].Id,
                        "Type": 1
                    }
                    this.section1 = section1;
                    console.log('section1', section1);
                }

                if (data.Sections.length >= 2) {
                    let section2 = {
                        "ChoiceSetId": data.Sections[1].ChoiceSetId,
                        "Id": data.Sections[1].Id,
                        "Order": data.Sections[1].Id,
                        "Type": 2
                    }
                    this.section2 = section2;
                    console.log('section2', section2);
                }
                
                this.deleted_section1_questions = this._Globals.section1Deleted;
                this.deleted_section2_questions = this._Globals.section2Deleted;

            } else {
                this._AssessmentsService.getAssessment(this.assessmentId).subscribe((data: any) => {
                    console.log('get360Assessment', JSON.parse(data.result.Data));
                    console.log('data', JSON.parse(data.result.Data));

                    if (this._Globals.validationToken(data.result.Result)) {

                        let _data = JSON.parse(data.result.Data);
                        console.log('response_Get360Assessment', data.result);
                        this.majorVersion = _data.MajorVersion;
                        this.minorVersion = _data.MinorVersion;
                        this.name = _data.Name;
                        this.nicheName = _data.NicheName;
                        this.regularAssessment = _data.RegularAssessment;

                        if (_data.Sections.length == 0) {
                            this.toastr.error('No choices', 'ELI');
                        } else {

                            this.section1ChoiceSet = parseInt(_data.Sections[0].ChoiceSetId);
                            this.section2ChoiceSet = parseInt(_data.Sections[1].ChoiceSetId);
                            this.templateId = parseInt(_data.TemplateId);

                            if (_data.Sections.length >= 1)
                                this.section1_questions = _data.Sections[0].Questions;
                            if (_data.Sections.length >= 2)
                                this.section2_questions = _data.Sections[1].Questions;


                            if (_data.Sections.length >= 1) {
                                let section1 = {
                                    "ChoiceSetId": _data.Sections[0].ChoiceSetId,
                                    "Id": _data.Sections[0].Id,
                                    "Order": _data.Sections[0].Id,
                                    "Type": 1
                                }
                                this.section1 = section1;
                                console.log('section1', section1);
                            }

                            if (_data.Sections.length >= 2) {
                                let section2 = {
                                    "ChoiceSetId": _data.Sections[1].ChoiceSetId,
                                    "Id": _data.Sections[1].Id,
                                    "Order": _data.Sections[1].Id,
                                    "Type": 2
                                }
                                this.section2 = section2;
                                console.log('section2', section2);
                            }

                            if (_data.Sections.length >= 3) {
                                let section3 = {
                                    "ChoiceSetId": _data.Sections[2].ChoiceSetId,
                                    "Id": _data.Sections[2].Id,
                                    "Order": _data.Sections[2].Id,
                                    "Type": 3
                                }
                                this.section3 = section3;
                                console.log('section3', section3);
                            }
                        }
                    }              

                });
            }


        } 
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('Get Niches', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;

                if (this.nicheId != 0) {
                    this.getAssessmentsByNiche(this.niches[this.nicheId].Id);
                } else {
                    this.getAssessmentsByNiche(this.niches[0].Id);
                }

            }
        });
    }

    getAssessmentsByNiche(nicheId: number) {

        this._AdminService.getAssessmentsByNiche(nicheId).subscribe((data: any) => {
            console.log('response_GetAssessmentsByNiche', JSON.parse(data.result.Data));

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.baseEli = _data;
            }
        });
    }

    selectNiche(nicheId) {
        this.nicheId = parseInt(nicheId);
        console.log('nicheId', this.nicheId);
        this.getAssessmentsByNiche(this.nicheId);
    }

    GetChoiceSets(sectionType: number) {
        this._AdminService.getChoiceSets(sectionType).subscribe(data => {
            console.log('response_getChoiceSets', data);
            if (sectionType == 4) {
                this.section1ChoiceSets = data.result;
                this.section1ChoiceSet = data.result[0].Id;
                console.log('section1ChoiceSetDefault', this.section1ChoiceSet);
            }
            if (sectionType == 5) {
                this.section2ChoiceSets = data.result;
                this.section2ChoiceSet = data.result[0].Id;
                console.log('section2ChoiceSetDefault', this.section2ChoiceSet);
            }
        });
    }

    generateSectionsArray(): any[] {
        let sections: any[] = [];
        //this.removeTextFromQuestions(this.section1_questions);
        //this.removeTextFromQuestions(this.deleted_section1_questions);
        if (this.section1 == undefined) {
            let newSection = {
                "Id": 0,
                "Order": 1,
                "Type": 4,
                "Questions": []
            }
            this.section1 = newSection;
        }
        if (!this.excludeDeleted) {
            this.section1.Questions = this.section1_questions.concat(this.deleted_section1_questions);
            if (this.section1ChoiceSet != undefined) {
                this.section1.ChoiceSetId = this.section1ChoiceSet;
            }

        } else {
            this.section1.Questions = this.section1_questions;
            this._Globals.section1Deleted = this.deleted_section1_questions;
        }
        sections.push(this.section1);

        //this.removeTextFromQuestions(this.section2_questions);
        //this.removeTextFromQuestions(this.deleted_section2_questions);
        if (this.section2 == undefined) {
            let newSection = {
                "Id": 0,
                "Order": 2,
                "Type": 5,
                "Questions": []
            }
            this.section2 = newSection;
        }
        if (!this.excludeDeleted) {
            this.section2.Questions = this.section2_questions.concat(this.deleted_section2_questions);
            if (this.section2ChoiceSet != undefined) {
                this.section2.ChoiceSetId = this.section2ChoiceSet;
            }
        } else {
            this.section2.Questions = this.section2_questions;
            this._Globals.section2Deleted = this.deleted_section2_questions;
        }
        sections.push(this.section2);
        
        console.log('sections', sections);

        return sections;
    }

    selectSectionChoiceSet(sectionType: number, selectedChoiceSet: string) {
        console.log('sectionType', sectionType);
        console.log('selectedChoiceSet', selectedChoiceSet);

        switch (sectionType) {
            case 1: {
                this.section1ChoiceSet = parseInt(selectedChoiceSet);
                break;
            }
            case 2: {
                this.section2ChoiceSet = parseInt(selectedChoiceSet);
                break;
            }

        }
    }

    saveAssessment() {


        console.log('save');
        let postSaveAssessmentData = this.getPostValues();

        //let name = $('#name').val();
        if (postSaveAssessmentData.name == "") {
            this.toastr.warning('Name field empty', 'ELI');
            return;
        }
        //let niche = $("#niche").val();
        //let major = $("#major").val();
        //let minor = $("#minor").val();
        //let sections = this.generateSectionsArray();

        //let id = 0;
        //if (this.assessmentId != null)
        //{
        //    id = this.assessmentId
        //}


        let canPreviewAssessment = true;
        postSaveAssessmentData.sections.forEach((section) => {
            if (section.Questions.length == 0) {
                canPreviewAssessment = false;
                return;
            }
        });

        if (!canPreviewAssessment) {
            this.toastr.warning('Please add at least one question for each section', 'ELI');
            return;
        }

        let assessmentDto = new SaveAssessments360Dto();

        assessmentDto.id = postSaveAssessmentData.id,
        assessmentDto.name = postSaveAssessmentData.name;
        assessmentDto.niche = postSaveAssessmentData.niche;
        assessmentDto.majorVersion = postSaveAssessmentData.major;
        assessmentDto.minorVersion = postSaveAssessmentData.minor;
        assessmentDto.sections = postSaveAssessmentData.sections;
        assessmentDto.regularAssessmentId = postSaveAssessmentData.regularAssessmentId;

        console.log('assessmentDto', assessmentDto);
        console.log('postSaveAssessmentData BODY', JSON.stringify(assessmentDto));

        this._AssessmentsService.postSave360Assessment(assessmentDto).subscribe(data => {
            console.log('response PostSaveAssessments', data);
            if (data.result.Result > 0) {
                this.toastr.success('Done!.', 'ELI');
                this.router.navigate(['/app/360']);
            } else {
                this.toastr.error('Error!.', 'ELI');
            }

        });

    }

    getPostValues(): PostSaveAssessmentData {
        let postSaveAssessmentData = new PostSaveAssessmentData();
        postSaveAssessmentData.name = $('#name').val();
        postSaveAssessmentData.niche = $("#niche").val();
        postSaveAssessmentData.major = $("#major").val();
        postSaveAssessmentData.minor = $("#minor").val();
        postSaveAssessmentData.sections = this.generateSectionsArray();
        postSaveAssessmentData.regularAssessmentId = parseInt($("#baseEli").val());

        postSaveAssessmentData.id = 0;
        if (this.assessmentId != null) {
            postSaveAssessmentData.id = this.assessmentId
        }

        return postSaveAssessmentData;
    }

    //"DisplayMode": 1,
    //"Questions": [],
    //"SectionId": 1,
    //"ShowIcons": false,
    //"SingleChoice": true


    setSectionPreviewFormat(sectionId: number, section: any, displayMode: number, showIcons: boolean, singleChoice: boolean) {
        let newSection = section;

        newSection.DisplayMode = displayMode;
        newSection.SectionId = sectionId;
        newSection.ShowIcons = showIcons;
        newSection.SingleChoice = singleChoice;
        //delete newSection.Order;
        //delete newSection.Type;

        newSection.Questions.forEach((x) => {
            x.Answer = 0;
            //delete x.Order;
            //delete x.IsTestQuestion;
            //delete x.Status;

        });
        //console.log('newSection', newSection);
    }

    generatePreviewSections(): any[] {
        let sections: any[] = [];

        let section1 = this.section1;
        section1.Questions = this.section1_questions;
        this.setSectionPreviewFormat(1, section1, 1, false, true);
        sections.push(this.section1);

        let section2 = this.section2;
        this.section2.Questions = this.section2_questions;
        this.setSectionPreviewFormat(2, section2, 2, true, true);
        sections.push(this.section2);
        
        console.log('sections', sections);

        return sections;
    }

    previewMode() {
        if (this.assessmentId == undefined) {
            this.assessmentId = 0;
        }
        this._Globals.previewAssessmentId = this.assessmentId;
        const currentEditingAssessment = this.generateCurrentEditingAssesmentJson();
        this._Globals.currentEditingAssessment = currentEditingAssessment;

        console.log('globals', this._Globals);

        let sections = this.generatePreviewSections();

        let canPreviewAssessment = true;
        sections.forEach((section) => {
            if (section.Questions.length == 0) {
                canPreviewAssessment = false;
                return;
            }
        });

        if (!canPreviewAssessment) {
            this.toastr.warning('Please add at least one question for each section', 'ELI');
            return;
        }

        let previewAssessment = {
            "result": {
                "Id": 0,
                "Progress": {
                    "CurrentQuestion": 0,
                    "CurrentSection": 0
                },
                "Sections": sections
            }
        }

        this._Globals.previewModeJSON = previewAssessment;


        let previewAssessmentFinal = JSON.stringify(previewAssessment);
        console.log('preview Mode Assessment', previewAssessmentFinal);

        ///app/instructions','eli_assessments', assessmentId, 0
        this.router.navigate(['/app/assigned_assessment', 'eli_assessments', this.assessmentId, 0]);

    }

    generateCurrentEditingAssesmentJson(): any {
        //flag to handle the deleted questions
        this.excludeDeleted = true;
        let postSaveAssessmentData = this.getPostValues();
               
        let currentEditingAssessment = {
            "Id": postSaveAssessmentData.id,
            "MajorVersion": parseInt(postSaveAssessmentData.major),
            "MinorVersion": parseInt(postSaveAssessmentData.minor),
            "Name": postSaveAssessmentData.name,
            "NicheName": postSaveAssessmentData.niche,
            "Sections": postSaveAssessmentData.sections,
            "RegularAssessmentId": postSaveAssessmentData.regularAssessmentId
        }
        console.log('current Editing Assessment Data', JSON.stringify(currentEditingAssessment));
        return currentEditingAssessment;
    }

    getTemplatesByType() {
        this._AdminService.getTemplatesByType().subscribe(data => {
            console.log('Templates', data.result);
            this.templates = data.result;
        })
    }


    /*---------------------------------*/
    /*generic method for all ag-grids*/
    /*---------------------------------*/

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    move(arr, old_index, new_index) {
        while (old_index < 0) {
            old_index += arr.length;
        }
        while (new_index < 0) {
            new_index += arr.length;
        }
        if (new_index >= arr.length) {
            var k = new_index - arr.length;
            while ((k--) + 1) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

        //updating the new order
        for (var i = 0; i < arr.length; i++) {
            arr[i].Order = (i + 1);
        }

        return arr;
    }

    openTab(menu: string) {
        var res = menu.split("-");
        console.log(res);

        $('div').removeClass('active');
        $('div').removeClass('in');
        $('#' + res[1]).addClass('active');
        $('#' + res[1]).addClass('in');
        this.tabSelect(res[0]);
    }

    tabSelect(event: any) {
        event = parseInt(event);
        console.log(event);
        if (event == 3) {
            return;
        }

        let currentGridApi = this.getGridApiByType(event);
        this.sizeToFit(currentGridApi);
        //this.GetChoiceSets(event + 1); 

    }

    getGridApiByType(index: number) {
        switch (index) {
            case 0: {
                return this.section1GridApi;
            }
            case 1: {
                return this.section2GridApi;
            }
        }
    }

    //deleteFromAgGrid(rowIndex: number, questionsArray: any[], gridApi:any ) {
    //    var model = gridApi.getModel();
    //    model.rowsToDisplay.splice(rowIndex, 1);
    //    console.log('question to delete', questionsArray[rowIndex]);
    //    questionsArray.splice(rowIndex, 1);
    //    let items = questionsArray;
    //    questionsArray = [];
    //    setTimeout(() => {
    //        questionsArray = items;
    //        console.log(questionsArray);
    //        gridApi.redrawRows();
    //    }, 100);
    //}



    /*---------------------------------------------*/
    /*---------QUESTIONS MODAL ag-grid--------------*/
    /*---------------------------------------------*/

    showQuestions(questionType: number) {
        this.currentQuestionType = questionType;
        this.questionType = this.getQuestiontype(questionType);
        this.getQuestions(questionType);
        $('#questionsModal').modal('show');
    }

    getQuestions(questionType: number) {
//<<<<<<< HEAD
        //this._GetQuestions.getQuestions(questionType).subscribe((data: any) => {
        //    console.log('response_GetQuestions', data);
        //    if (this._Globals.validationToken(data.result.Result)) {
        //        let _data = JSON.parse(data.result.Data);
        //        console.log('_data', _data);

        //        this.questions = _data;
        //        setTimeout(() => {
        //            this.sizeToFit(this.questionsGridApi);
        //        }, 100);
        //    }
        //=======
        this._AdminService.getQuestions(questionType).subscribe((data: any) => {
            console.log('response_getQuestions', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
//>>>>>>> 27b2aca204f1820bd88692508dcafc870121e6b8

                this.questions = _data;
                console.log('questionType: ' + questionType, _data);
                setTimeout(() => {
                    this.sizeToFit(this.questionsGridApi);
                }, 100);
            } 
        });
    }

    getQuestiontype(type: number): string {
        switch (type) {
            case 4: {
                return 'Section 1';
            }
            case 5: {
                return 'Section 2';
            }
            default: {
                return '';
            }
        }
    }

    addQuestions() {
        let selectedQuestions = this.getSelectedRows();
        switch (this.currentQuestionType) {
            case 1: {
                this.setSelectedQuestions(selectedQuestions, this.section1_questions, this.section1GridApi, this.deleted_section1_questions);
                console.log('array', this.section1_questions);
                break;
            }
            case 2: {
                this.setSelectedQuestions(selectedQuestions, this.section2_questions, this.section2GridApi, this.deleted_section2_questions);
                console.log('array', this.section2_questions);
                break;
            }
        }
        $('#questionsModal').modal('hide');
    }

    setSelectedQuestions(selectedQuestions, array: any[], gridApi, deletedArray) {
        selectedQuestions.forEach((selectedRow, index) => {
            console.log('selectedRow index: ' + index, selectedRow);
            let currentQuestionId = selectedRow.Id;
            let pos = array.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
            if (pos == -1) {
                //set new order
                let order = array.length + 1;
                selectedRow.Order = order;

                array.push(selectedRow);
                //this.removeNewFromDeletedIfExist(deletedArray, currentQuestionId);
                let existInDeleted = this.existInDeletes(deletedArray, currentQuestionId);
                if (existInDeleted) {
                    selectedRow.Status = 1;
                }
                var res = gridApi.updateRowData({ add: [selectedQuestions[index]] });
            }

        });
        this.sizeToFit(gridApi);
    }

    existInDeletes(array: any[], newQuestionId: number): boolean {
        if (array.length > 0) {
            let pos = array.map(function (e) { return e.Id; }).indexOf(newQuestionId);
            if (pos != -1) {
                array.splice(pos, 1);
                console.log('deleted array', array);
                return true;
            } else {
                return false;
            }

        }
    }

    removeNewFromDeletedIfExist(array: any[], newQuestionId: number) {
        if (array.length > 0) {
            let pos = array.map(function (e) { return e.Id; }).indexOf(newQuestionId);
            if (pos != -1) {
                array.splice(pos, 1);
                console.log('deleted array', array);
            }
        }
    }

    getSelectedRows(): any {
        return this.questionsGridApi.getSelectedRows();
    }

    onQuestionsGridReady(params) {
        this.questionsGridApi = params.api;
        this.sizeToFit(this.questionsGridApi);
    }

    createModalHeaders() {
        let columnDefs = new Array();
        //console.log('header');
        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            sort: 'asc',
            minWidth: 50,
            width: 50,
            hide: true,
            pinned: 'left',
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 1000,
            width: 1000,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    public onQuestionsRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            switch (e.event.target.id) {
                case "editAction":
                    {
                        break;
                    }

                case "deleteAction":
                    {
                        break;
                    }
            }
        }
    }


    /*---------------------------------------------*/
    /*---------SECTION1 QUESTIONS ag-grid------------*/
    /*---------------------------------------------*/

    onSection1GridReady(params) {
        this.section1GridApi = params.api;
        this.sizeToFit(this.section1GridApi);
    }

    createSection1Headers() {
        let columnDefs = new Array();
        //console.log('header');

        //console.log('header');
        //let idHeader = {
        //    headerName: 'Id',
        //    field: 'Id',
        //    minWidth: 200,
        //    width: 200,
        //    hide: true,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(idHeader);

        let positionHeader = {
            headerName: '',
            field: '',
            rowDrag: true,
            minWidth: 75,
            width: 75,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                console.log(params);
                return parseInt(params.rowIndex) + 1;
            }
        };
        columnDefs.push(positionHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let checkHeader = {
            headerName: 'Test Question',
            field: 'TestQuestion',
            minWidth: 125,
            width: 125,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let checked = params.data.IsTestQuestion;
                let rowIndex = params.node.rowIndex;
                if (checked) {
                    //return '<input type="checkbox" id="check" value="" checked>';
                    return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                } else {
                    //return '<input type="checkbox" id="check" value="">';
                    return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" unchecked><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                }
            }
        };
        columnDefs.push(checkHeader);

        let actionsHeader = {
            headerName: 'Actions',
            field: '',
            minWidth: 200,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="deleteSection1" class="material-icons custom-icons">delete</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);

        return columnDefs;
    }

    public onSection1RowClicked(e) {
        console.log(e);
        let rowIndex = e.rowIndex;
        if (e.event.target !== undefined) {
            let data = e.data;
            let checkboxrowindex = `c${rowIndex}`;

            switch (e.event.target.id) {

                case "deleteSection1":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.deleteSection1(rowIndex);
                        break;
                    }
                case checkboxrowindex:
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.setsection1CheckboxValue(rowIndex, data['IsTestQuestion']);
                        break;
                    }
            }
        }
    }

    setsection1CheckboxValue(index, value: boolean) {
        this.section1_questions[index].IsTestQuestion = !value;
        console.log(this.section1_questions[index]);
    }

    deleteSection1(rowIndex: number) {
        var model = this.section1GridApi.getModel();
        model.rowsToDisplay.splice(rowIndex, 1);
        console.log('question to delete', this.section1_questions[rowIndex]);

        //adding deleted question
        this.section1_questions[rowIndex].Status = 2;

        let currentQuestionId = this.section1_questions[rowIndex].Id;
        let pos = this.deleted_section1_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
        if (pos == -1) {
            this.deleted_section1_questions.push(this.section1_questions[rowIndex]);
        }
        console.log('deleted section1 questions', this.deleted_section1_questions);

        //removing from regularSection questions array
        this.section1_questions.splice(rowIndex, 1);
        let items = this.section1_questions;
        this.section1_questions = [];
        setTimeout(() => {
            this.section1_questions = items;
            console.log('section1_questions', this.section1_questions);
            this.section1GridApi.redrawRows();
        }, 0);

        //this.deleteFromAgGrid(rowIndex, this.section1_questions, this.section1GridApi);
    }

    onRowDragEnter(e) {
        console.log("onRowDragEnter", e);
        this._onRowDragEnter = e.overIndex;
        console.log('old', this._onRowDragEnter + 1);
    }

    onRowDragEnd(e, array) {
        console.log('array', array);
        console.log("onRowDragEnd", e);
        this._onRowDragEnd = e.overIndex;
        array = this.move(array, this._onRowDragEnter, this._onRowDragEnd);
        console.log('array', array);
        console.log('new', this._onRowDragEnd + 1);

        var model = this.section1GridApi.getModel();
        console.log(model);

        this.section1GridApi.redrawRows();
        this.section2GridApi.redrawRows();

    }

    /*---------------------------------------------*/
    /*------SECTION2 QUESTIONS ag-grid----------*/
    /*---------------------------------------------*/

    onSection2GridReady(params) {
        this.section2GridApi = params.api
        this.sizeToFit(this.section2GridApi);
    }

    createSection2Headers() {
        let columnDefs = new Array();
        //console.log('header');
        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            minWidth: 200,
            width: 200,
            hide: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        let positionHeader = {
            headerName: '',
            field: '',
            rowDrag: true,
            minWidth: 75,
            width: 75,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                console.log(params);
                return parseInt(params.rowIndex) + 1;
            }
        };
        columnDefs.push(positionHeader);

        let nameHeader = {
            headerName: 'Text',
            field: 'Text',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let testHeader = {
            headerName: 'Test Question',
            field: 'TestQuestion',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let checked = params.data.IsTestQuestion;
                let rowIndex = params.node.rowIndex;
                if (checked) {
                    //return '<input type="checkbox" id="check" value="" checked>';
                    return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" checked=""><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                } else {
                    //return '<input type="checkbox" id="check" value="">';
                    return '<div style="padding-left: 0px !important;" class="checkbox"><input id="check' + rowIndex + '" type="checkbox" unchecked><label id="c' + rowIndex + '" for="check' + rowIndex + '"></label></div>';
                }
            }
        };
        columnDefs.push(testHeader);

        let actionsHeader = {
            headerName: 'Actions',
            field: '',
            minWidth: 200,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="deleteSection2" class="material-icons custom-icons">delete</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);

        return columnDefs;
    }

    public onSection2RowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            let rowIndex = e.rowIndex;
            let checkboxrowindex = `c${rowIndex}`;

            switch (e.event.target.id) {

                case "deleteSection2":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.deleteSection2(rowIndex);
                        break;
                    }
                case checkboxrowindex:
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.setSection2CheckboxValue(rowIndex, data['IsTestQuestion']);
                        break;
                    }
            }
        }
    }

    setSection2CheckboxValue(index, value: boolean) {
        this.section2_questions[index].IsTestQuestion = !value;
        console.log(this.section2_questions[index]);
    }


    deleteSection2(rowIndex: number) {
        var model = this.section2GridApi.getModel();
        model.rowsToDisplay.splice(rowIndex, 1);
        console.log('question to delete', this.section2_questions[rowIndex]);

        //adding deleted question
        this.section2_questions[rowIndex].Status = 2;

        let currentQuestionId = this.section2_questions[rowIndex].Id;
        let pos = this.deleted_section2_questions.map(function (e) { return e.Id; }).indexOf(currentQuestionId);
        if (pos == -1) {
            this.deleted_section2_questions.push(this.section2_questions[rowIndex]);
        }
        console.log('deleted section2 questions', this.deleted_section2_questions);

        this.section2_questions.splice(rowIndex, 1);
        let items = this.section2_questions;
        this.section2_questions = [];
        setTimeout(() => {
            this.section2_questions = items;
            console.log(this.section2_questions);
            this.section2GridApi.redrawRows();
        }, 0);
    }


  //TAGS
  //removeTag(index, event: any) {
  //    //console.log(event);
  //    //event.target.parentNode.remove();

  //    this.tags.splice(index, 1);
  //    console.log(this.tags);
  //  }

  //addTag(tag: string) {
  //    let split_tags = tag.split(',');
  //    for (var i = 0; i < split_tags.length; i++) {
  //        //tag = tag.replace(" ", "_");
  //        var exist = this.tags.indexOf(split_tags[i]);
  //        if (exist != -1) {
  //            //alert("This Tag is already exist");
  //            //return;
  //        } else {
  //            this.tags.push(split_tags[i]);
  //            console.log(this.tags);
  //            $('#newTag').val('');
  //        }

  //    }

  //}

  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          $('#newTag').val('');
      }
    }

    preventLetters(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
            console.log('');
        }
    }
}

class PostSaveAssessmentData implements IPostSaveAssessmentData {
    id: number;
    name: string;
    niche: string;
    major: string;
    minor: string;
    sections: any;
    regularAssessmentId: number;
}
interface IPostSaveAssessmentData {
    id: number;
    name: string;
    niche: string;
    major: string;
    minor: string;
    sections: any;
    regularAssessmentId: number;
}
